export const contactNames = ["Whatsapp", "SMS", "E-mail", "Telefone"];
